
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaPauseGoogle as ObiMediaPauseGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-pause-google.js';
 
 
 

 
 export const ObiMediaPauseGoogle = createComponent({
   react: React,
   tagName: 'obi-media-pause-google',
   elementClass: ObiMediaPauseGoogleElement,
   events: {
     
   }
  });
 
 